import { FixingMode } from "@/data/fixingMode";

const FIXING_ASSET_CLASS_1 = new Set([
  "cash",
  "diversified_investments",
  "fixed_income",
  "equity",
]);

const VALORISATION_ASSET_CLASS_1 = new Set(["real_estate"]);

export function computeC3FixingMode(
  assetClass1?: string,
): FixingMode | null {
  if (!assetClass1) return null;

  const normalizedAssetClass1 = assetClass1.trim().toLowerCase();

  if (FIXING_ASSET_CLASS_1.has(normalizedAssetClass1)) {
    return FixingMode.FIXING;
  }

  if (VALORISATION_ASSET_CLASS_1.has(normalizedAssetClass1)) {
    return FixingMode.VALORISATION;
  }

  return null;
}

const isFiniteNumber = (v: unknown): boolean =>
  typeof v === "number" && Number.isFinite(v);

const getC3AssetClass1 = (data: any): string | undefined =>
  data?.c3_static_datum_asset_class_1 ?? data?.c3_static_datum_name?.asset_class_1 ?? undefined;

export const requiresC3MarketValue = (data: any) => {
  const mode = computeC3FixingMode(getC3AssetClass1(data));
  return mode !== FixingMode.VALORISATION || isFiniteNumber(data.market_value);
};

export const requiresC3Fixing = (data: any) => {
  const mode = computeC3FixingMode(getC3AssetClass1(data));
  return mode !== FixingMode.FIXING || isFiniteNumber(data.fixing);
};
